// @ts-nocheck
import { object, string } from 'yup'

export default object().shape({
  email: string().email().required('Please enter your email'),
  password: string().required('Please enter your password')
})
